<template>
  <div
    v-loading.fullscreen="loading"
    element-loading-text
    element-loading-spinner="el-icon-loading"
    class="moow-master-container"
  >
    <header-alt :overlay="true"></header-alt>
    <b-container fluid class="landlord-container-hero">
      <div class="container vert-cent">
        <b-row>
          <b-col lg="7" md="12" sm="10" xs="12">
            <b-collapse visible id="filterform">
              <md-card md-with-hover class="mo-card transwhite mt-5">
                <md-card-header>
                  <div class="moow-hero-title mt-5">{{i18n_local.landlord.hero_headline}}</div>
                </md-card-header>

                <md-card-content>
                  <p class="moow-info-txt large">{{i18n_local.landlord.hero_subheadline}}</p>
                  <p class="moow-info-txt large">{{i18n_local.landlord.hero_subheadline_2}}</p>
                  <p class="moow-info-txt">{{i18n_local.landlord.user_for_free}}</p>
                </md-card-content>

                <md-card-actions>
                  <md-button
                    class="md-primary play-cta-button-flat makeup"
                    @click="openContactUsForm()"
                  >{{i18n_local.contact_sales}}</md-button>
                  <md-button
                    class="md-primary play-cta-button makeup"
                    style="text-decoration:none"
                    to="/register"
                  >{{i18n_local.sign_up}}</md-button>
                </md-card-actions>
              </md-card>
            </b-collapse>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-container class="landlord-container-how">
      <b-row class="mt-3" style="padding: 30px 0 30px 0;">
        <b-col>
          <b-row class="mb-3">
            <b-col>
              <p class="moow-header large makeup">{{i18n_local.landlord.what_one_title}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="0" sm="6">
              <div class="moow-info-list mb-2">
                <p>{{i18n_local.landlord.what_one_body}}</p>
                <p>{{i18n_local.landlord.what_one_body_2}}</p>
                <p>{{i18n_local.landlord.what_one_body_3}}</p>
              </div>
              <md-button
                class="md-raised md-primary play-cta-button"
                style="text-decoration:none"
                to="/prediction"
              >{{i18n_local.landlord.free_rent_validation}}</md-button>
            </b-col>
            <b-col style="text-align:center" cols="0" sm="6">
              <img :src="listIcon" class="how-icon-holder" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <md-divider class="moow-divider"></md-divider>

      <b-row class="mt-3" style="padding: 30px 0 30px 0;">
        <b-col>
          <b-row class="mb-3">
            <b-col>
              <p
                class="moow-header large makeup"
                style="text-align:right"
              >{{i18n_local.landlord.what_two_title}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align:center" cols="0" sm="6">
              <img :src="connectIcon" class="how-icon-holder" />
            </b-col>
            <b-col cols="0" sm="6" style="text-align:right">
              <div class="moow-info-list mb-2" style="text-align:right">
                <p>{{i18n_local.landlord.what_two_body}}</p>
                <p>{{i18n_local.landlord.what_two_body_2}}</p>
              </div>
              <md-button
                class="md-primary play-cta-button makeup"
                style="width: 50%;text-decoration:none;margin:0 auto"
                @click="showContactForm=true"
              >{{i18n_local.landlord.req_demo}}</md-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <md-divider class="moow-divider"></md-divider>

      <b-row class="mt-3 mb-5" style="padding: 30px 0 30px 0;">
        <b-col>
          <b-row class="mb-3">
            <b-col>
              <p class="moow-header large makeup">{{i18n_local.landlord.what_three_title}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="0" sm="6">
              <div class="moow-info-list mb-2">
                <p>{{i18n_local.landlord.what_three_body}}</p>
                <p>{{i18n_local.landlord.what_three_body_2}}</p>
                <p>{{i18n_local.landlord.what_three_body_3}}</p>
              </div>
              <md-button
                class="md-raised md-primary play-cta-button"
                style="text-decoration:none"
                to="/register"
              >{{i18n_local.landlord.sign_up_for_free}}</md-button>
            </b-col>
            <b-col style="text-align:center" cols="0" sm="6">
              <img :src="peaceIcon" class="how-icon-holder" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="landlord-container-final">
      <b-row>
        <b-col style="text-align: center">
              <p class="moow-header large makeup" style="text-align: center">{{i18n_local.landlord.add_your_property}}</p>
              <p class="moow-info-txt" style="text-align: center">{{i18n_local.landlord.add_your_property_sub}}</p>
              <md-button
                class="md-raised md-primary play-cta-button makeup"
                style="text-decoration:none;margin:0 auto"
                to="/register"
              >{{i18n_local.landlord.add_property}}</md-button>
        </b-col>
      </b-row>
      <b-row class="mt-5 pb-5" >
        <b-col style="text-align: center">
              <img :src="moowLogo" class="logo-holder" style="margin:0auto"/>

        </b-col>
      </b-row>
    </b-container>

    <md-dialog :md-active.sync="showContactForm">
      <contact-form @closeForm="closeContactUsForm"></contact-form>
    </md-dialog>

    <md-snackbar :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
    </md-snackbar>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import { getPlacePredictions } from "../mapsRepository.js";
import {
  getStartingFromDisplayPrice,
  calcPricingTier,
  getDefaultStartingFromPrices
} from "../pricing/pricingCalculator.js";
import ContactUsForm from "./dialogs/ContactUsForm.vue";
import TermsAndConditions from "../components/dialogs/TermsAndConditions";
import Footer from "../components/footer/Footer";
import { mapGetters } from "vuex";

export default {
  name: "landlord",
  components: {
    "contact-form": ContactUsForm,
    "terms-conditions": TermsAndConditions,
    "moow-footer": Footer
  },
  validator: null,
  data() {
    return {
      showTerms: false,
      showSnackbar: false,
      snackbarMessage: "",
      previewListingImages: [],
      previewImageUrl: "",
      showImgPreview: false,
      searchInput: "",
      filterPriceBy: "",
      displayPriceTier: "monthly",
      noListings: false,
      showAddressSeachOnHeader: false,
      loading: false,
      placesPredictions: [],
      selectedPlace: "",
      filterMuni: undefined,
      filterPriceFrom: undefined,
      filterPriceTo: undefined,
      filterBedroomsMin: undefined,
      filterBedroomsMax: undefined,
      loadingListings: false,
      filteredListings: [],
      sortedListings: [],
      loggedInAs: false,
      userIsAnonymous: true,
      currentUser: undefined,
      loadingAdditionalListings: false,
      inListView: false,
      showFilterForm: true,
      selectedSort: "",
      sortListings: false,
      moreListingsAvailable: true,
      filterTags: [],
      showFilterTags: false,
      somethingIsBroken: false,
      selectedImageIdx: 0,
      filterTagsArr: [],
      previewListingId: "",
      showContactForm: false
    };
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    moowLogo() {
      return require("../assets/logos/moowle-logo-white.png");
    },
    listIcon() {
      return require("../assets/icons/chat.png");
    },
    connectIcon() {
      return require("../assets/icons/properties.png");
    },
    peaceIcon() {
      return require("../assets/icons/email1.png");
    },
    interImg() {
      return require("../assets/images/interior_l1.jpg");
    },
    filterButtonText() {
      if (this.filterHasInput()) return "Find";
      else return "Scroll down";
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    openContactUsForm() {
      this.showContactForm = true;
    },
    closeContactUsForm(isSuccess) {
      this.showContactForm = false;
      if (isSuccess == true)
        this.notifyUser("Thank You. We will be in touch promptly");
      else if (isSuccess == false)
        this.notifyUser("Something is not right, contact support@moowle.com");
    },
    notifyUser(msg) {
      this.snackbarMessage = msg;
      this.showSnackbar = true;
    }
  }
};
</script>

<style scoped>
@import "../assets/styles/global.css";
@import "../assets/styles/listings-view.css";
@import "../assets/styles/portal.css";

.landlord-container-final{
  background-color: #414042;
}

.landlord-container-final p {
  color: white;
}

.logo-holder{
  height: 100px;
}

.how-icon-holder {
  height: 300px;
  border-radius: 8px;
}

.marketplace-element-container-clickable {
  background-color: white;
  border-radius: 10px;
  width: 100%;
  margin: 0 auto;
}

.no-listings-found {
  height: 200px;
  width: 200px;
  text-align: center;
}

.md-chip {
  background-color: rgba(74, 74, 253, 0.37);
  color: white;
  font-weight: bold;
}
.md-autocomplete {
  background-color: white;
  opacity: 1;
}

.md-menu-content.md-select-menu {
  background-color: white !important;
}
.md-menu-content.md-autocomplete-box-content {
  background-color: white !important;
}

.mo-listing-card {
  border-radius: 10px;
  margin: 10px;
  display: inline-block;
  vertical-align: top;
  width: 31.5%;
  padding: 1em;
  height: 520px;
}

.sort-menu {
  max-width: 300px;
}

/*  from infinity to max 1200 and then this kicks in*/
@media (min-width: 700px) {
  .hero-campaign-cta {
    position: absolute;
    bottom: 0;
    margin: 0 auto;
    right: 0;
  }
}

/*  from infinity to max 1200 and then this kicks in*/
@media (max-width: 1200px) {
  .mo-listing-card {
    width: 49%;
  }
}
/*  from infinity to max 700 and then this kicks in*/
@media (max-width: 700px) {
  .mo-listing-card {
    width: 100%;
  }

  #result-title {
    display: none;
  }

  .sort-menu {
    max-width: 100px;
  }
}

.marketplace-element-container-clickable .daily-price {
  display: none;
}
.marketplace-element-container-clickable:hover .daily-price {
  display: inline;
}
.marketplace-element-container-clickable:hover .monthly-price {
  display: none;
}

.mo-listing-card .daily-price {
  display: none;
}
.mo-listing-card:hover .daily-price {
  display: inline;
}
.mo-listing-card:hover .monthly-price {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Landlord.vue